"use client"
import type { FragmentOf, Timeframe } from "@opensea/graphql"
import { graphql, readFragment } from "@opensea/graphql"
import { ChangeAnimation, StatChange } from "@opensea/ui-kit"

export const StatsTableRowFloorChangeFragment = graphql(`
  fragment StatsTableRowFloorChange on Collection {
    stats {
      oneMinute {
        floorPriceChange
      }
      fiveMinute {
        floorPriceChange
      }
      fifteenMinute {
        floorPriceChange
      }
      oneDay {
        floorPriceChange
      }
      oneHour {
        floorPriceChange
      }
      sevenDays {
        floorPriceChange
      }
      thirtyDays {
        floorPriceChange
      }
    }
  }
`)

type Props = {
  className?: string
  collection: FragmentOf<typeof StatsTableRowFloorChangeFragment>
  timeframe: Timeframe
}

function getFloorPriceChange({ timeframe, collection: key }: Props) {
  const collection = readFragment(StatsTableRowFloorChangeFragment, key)
  switch (timeframe) {
    case "ONE_MINUTE":
      return collection.stats.oneMinute.floorPriceChange
    case "FIVE_MINUTE":
      return collection.stats.fiveMinute.floorPriceChange
    case "FIFTEEN_MINUTE":
      return collection.stats.fifteenMinute.floorPriceChange
    case "ALL_TIME":
      return null
    case "ONE_DAY":
      return collection.stats.oneDay.floorPriceChange
    case "ONE_HOUR":
      return collection.stats.oneHour.floorPriceChange
    case "SEVEN_DAYS":
      return collection.stats.sevenDays.floorPriceChange
    case "THIRTY_DAYS":
      return collection.stats.thirtyDays.floorPriceChange
    default:
      return null
  }
}

export function StatsTableRowFloorChange({ timeframe, collection }: Props) {
  const floorChange = getFloorPriceChange({ timeframe, collection })

  return (
    <ChangeAnimation display="percent" value={floorChange}>
      <StatChange change={floorChange} />
    </ChangeAnimation>
  )
}
